!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@material-ui/core"), require("@material-ui/icons"), require("react"), require("react-beautiful-dnd")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/core", "@material-ui/icons", "react", "react-beautiful-dnd"], t) : t((e = e || self)["draggable-list"] = {}, e.core, e.icons, e.React, e.reactBeautifulDnd);
}(this, function (e, t, n, r, a) {
  "use strict";

  var i = "default" in r ? r.default : r,
      _o = function o() {
    return (_o = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var a in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);

      return e;
    }).apply(this, arguments);
  },
      l = function l(e, t, n) {
    var r = Array.from(e),
        a = r.splice(t, 1)[0];
    return r.splice(n, 0, a), r;
  },
      c = function c(e) {
    var t = e.style,
        r = e.id,
        a = e.dragHandleProps,
        l = e.className;
    return i.createElement("div", _o({
      id: r
    }, a, {
      style: {
        height: "100%",
        display: "flex",
        alignContent: "center",
        alignItems: "center"
      }
    }), i.createElement(n.DragIndicator, {
      className: l,
      style: t
    }));
  };

  c.defaultProps = {
    id: "draggable-handle",
    style: {
      fontSize: 15,
      height: "100%"
    }
  };
  var s = r.memo(function (e) {
    var n = e.children,
        r = e.id,
        l = e.index,
        c = e.style,
        s = e.className;
    return i.createElement(t.Box, {
      key: r
    }, i.createElement(a.Draggable, {
      key: r,
      draggableId: r,
      index: l
    }, function (e) {
      return i.createElement("div", _o({
        ref: e.innerRef
      }, e.draggableProps, e.dragHandleProps), i.createElement(t.ListItem, {
        className: s,
        style: _o({
          padding: 0
        }, c)
      }, n));
    }));
  }),
      d = r.memo(function (e) {
    var n = e.children,
        c = e.onReorder,
        s = e.style,
        d = e.className,
        u = r.useState(n),
        f = u[0],
        m = u[1];
    r.useEffect(function () {
      m(n);
    }, [n]);
    return i.createElement(a.DragDropContext, {
      onDragEnd: function onDragEnd(e) {
        return function (e) {
          if (e.destination && e.destination.index !== e.source.index) {
            var t = l(f, e.source.index, e.destination.index);
            m(t), c && c(e.source.index, e.destination.index, l);
          }
        }(e);
      }
    }, i.createElement(a.Droppable, {
      droppableId: "list"
    }, function (e, n) {
      var r = n.isDraggingOver ? _o({
        pointerEvents: "none"
      }, s) : s;
      return i.createElement(t.RootRef, {
        rootRef: e.innerRef
      }, i.createElement(t.List, {
        style: r,
        className: d
      }, f.map(function (e, t) {
        return i.cloneElement(e, {
          index: t
        });
      }), e.placeholder));
    }));
  });
  Object.keys(a).forEach(function (t) {
    "default" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return a[t];
      }
    });
  }), e.DraggableList = d, e.DraggableListItem = s, e.DraggableListItemHandle = c, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});